import { makeStyles } from "components/mui-core";
import { ReactComponent as ChangeHistoryIcon } from "icons/changeHistory/change-history.svg";
import React from "react";
import { ChangeHistoryDialog } from "./ChangeHistoryDialog";

const useStyles = makeStyles()({
  icon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const ChangeHistory = () => {
  const { classes } = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <div
        className={classes.icon}
        onClick={() => setOpen(true)}>
        <ChangeHistoryIcon />
      </div>

      <ChangeHistoryDialog
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
